// Normalize backend error messages to a consistent, user-friendly format and
// tag password-protected PDF errors explicitly so the UI can render guidance.
export function enhanceErrorMessage(originalMessage: string | undefined): string {
  const message = (originalMessage || '').toString();
  const lower = message.toLowerCase();
  const passwordIndicators = [
    'incorrect password',
    'invalid encryption key length',
    'need user password',
    'encrypted',
    'permission',
    'password protected',
    'password-protected',
    'owner password',
    'user password'
  ];
  const isPasswordIssue = passwordIndicators.some(ind => lower.includes(ind));
  if (isPasswordIssue) {
    return (
      '🔒 Password-protected PDF detected. Switching to OCR automatically — no action needed. Processing may take a bit longer.'
    );
  }
  return message || 'Processing failed';
}

